App.controller('HealthPzuwRefundCtrl', ['$scope', '$sce', '$state', '$http', 'packageService', '$stateParams', function ($scope, $sce, $state, $http, packageService, $stateParams) {
    $scope.stateParams = $stateParams;

    $scope.page = 'healthInsurancePzuw_refund';
    $scope.$emit('page', $scope.page);

    $scope.step = 'Reklamacje/refundacje';
    $scope.$emit('step', $scope.step);

    $scope.link = 'root.health.start';
    $scope.$emit('link', $scope.link);

    setTimeout(function () {
        window.location.href = "/";
    }, 1);
}]);
